import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

/**
 * Formly field type for telephone input
 * Uses HTML5 tel input for mobile keyboard optimization
 *
 * Props:
 * - label: string - Field label
 * - placeholder: string - Placeholder text (e.g., "(555) 123-4567")
 * - description: string - Helper text
 * - required: boolean - Whether value is required
 * - pattern: string - Regex pattern for validation
 */
@Component({
  selector: 'app-tel-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './tel-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tel-field.component.css',
})
export class TelFieldComponent extends FieldType<FieldTypeConfig> {}
